import React, { useContext } from "react";
import { DataTable, HighlightMatch, Table, ValueOrPlaceholder } from "@sscs/ui";
import { capitalizeFirstLetter, getQueryStatus } from "@sscs/utils";
import { FILE_BROWSER_ROUTES, REPORT_PAGES_ROUTES, } from "../../../../constants";
import { expandedRowPaginationUpdated, expandedRowSortUpdated, expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectExpandedRowPagination, selectExpandedRowSort, selectFilter, selectFocusedRow, } from "../../../../store/cbomSlice";
import { ComponentList, ExpandedRowDetails } from "../../../../ui";
import { ComponentName, ComponentPriorityAndIssuesLink, IssuesList, } from "../../../common";
import { ReportContext } from "../../../context";
import { useReportDispatch, useReportSelector } from "../../../hooks";
import { useGetCryptoAssetDetailsQuery } from "../../../services/cbom.api";
import { transformMaterialType } from "../../../utils";
import Algorithm from "./Algorithm";
import Certificate from "./Certificate";
import Material from "./Material";
import Protocol from "./Protocol";
const Components = ({ cryptoAsset, rowIndex, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId } = useContext(ReportContext);
    const pagination = useReportSelector((state) => selectExpandedRowPagination(state, cryptoAsset.id));
    const sortBy = useReportSelector((state) => selectExpandedRowSort(state, cryptoAsset.id));
    const { data, isLoading, isFetching, isError, error } = useGetCryptoAssetDetailsQuery({
        ui_item_id: cryptoAsset.id,
        ui_id: reportId,
        sort: sortBy,
        pagination,
    });
    const handleSortChange = (newSort) => {
        dispatch(expandedRowSortUpdated({
            id: cryptoAsset.id,
            sort: newSort,
        }));
    };
    return (React.createElement(ComponentList.Table, { itemId: "crypto-asset-components", rowIndex: rowIndex, title: "Components that contain this cryptographic asset", matchCount: (_a = data === null || data === void 0 ? void 0 : data.match_count) !== null && _a !== void 0 ? _a : 0, queryStatus: getQueryStatus({
            isLoading,
            isFetching,
            isError,
            error,
            data,
        }), totalCount: cryptoAsset.component_count, pagination: pagination, onPaginationChange: (newPagination) => dispatch(expandedRowPaginationUpdated({
            id: cryptoAsset.id,
            pagination: newPagination,
        })), columns: ComponentList.columns({
            sortBy,
            rowIndex,
            onSortChange: handleSortChange,
        }) }, data === null || data === void 0 ? void 0 : data.components.map((component, index) => { var _a; return (React.createElement(Table.Row, { key: (_a = component.id) !== null && _a !== void 0 ? _a : component.path },
        React.createElement(Table.Cell, null, React.createElement(ComponentList.PriorityAndIssues, { component: component, id: index.toString(), badgeWrapper: (target, children) => (React.createElement(ComponentPriorityAndIssuesLink, { htmlId: index.toString(), componentId: component.id, componentPath: component.path, target: target }, children)) })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentName, { component: component, id: index.toString(), fileBrowserPage: FILE_BROWSER_ROUTES.INFO_ROUTE })),
        React.createElement(Table.Cell, null,
            React.createElement(ComponentList.Path, { path: component.path })))); })));
};
const CryptoAsset = ({ cryptoAsset, rowIndex, }) => {
    var _a;
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const focusedRow = useReportSelector(selectFocusedRow);
    const expanded = useReportSelector((state) => selectExpandedRow(state, cryptoAsset.id));
    let cryptoAssetSummary = null;
    let cryptoAssetDetails = null;
    if (cryptoAsset.kind === "ALGORITHM") {
        cryptoAssetSummary = React.createElement(Algorithm.Summary, { algorithm: cryptoAsset });
        cryptoAssetDetails = React.createElement(Algorithm.Details, { algorithm: cryptoAsset });
    }
    else if (cryptoAsset.kind === "CERTIFICATE") {
        cryptoAssetSummary = React.createElement(Certificate.Summary, { certificate: cryptoAsset });
        cryptoAssetDetails = React.createElement(Certificate.Details, { certificate: cryptoAsset });
    }
    else if (cryptoAsset.kind === "MATERIAL") {
        cryptoAssetSummary = React.createElement(Material.Summary, { material: cryptoAsset });
        cryptoAssetDetails = React.createElement(Material.Details, { material: cryptoAsset });
    }
    else if (cryptoAsset.kind === "PROTOCOL") {
        cryptoAssetSummary = React.createElement(Protocol.Summary, { protocol: cryptoAsset });
        cryptoAssetDetails = React.createElement(Protocol.Details, { protocol: cryptoAsset });
    }
    return (React.createElement(DataTable.ExpandedRow, { id: `cbom-expand-row-${rowIndex}`, expanded: expanded, onChange: (hasExpanded) => dispatch(expandedRowsUpdated({
            id: cryptoAsset.id,
            expand: hasExpanded,
        })), focused: focusedRow === cryptoAsset.id, onClick: () => dispatch(focusedRowUpdated(cryptoAsset.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null, capitalizeFirstLetter(cryptoAsset.kind.toLowerCase())),
            React.createElement(Table.Cell, null,
                React.createElement(HighlightMatch, { value: cryptoAsset.kind === "MATERIAL"
                        ? transformMaterialType(cryptoAsset.type)
                        : cryptoAsset.type, regex: (_a = filter.type) !== null && _a !== void 0 ? _a : "" })),
            React.createElement(Table.Cell, null, cryptoAssetSummary),
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: cryptoAsset.violations.length })),
            React.createElement(Table.Cell, null,
                React.createElement(ValueOrPlaceholder, { value: cryptoAsset.component_count }))),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    cryptoAssetDetails,
                    React.createElement(IssuesList, { violations: cryptoAsset.violations, to: REPORT_PAGES_ROUTES.ISSUES_ROUTE })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(Components, { cryptoAsset: cryptoAsset, rowIndex: rowIndex }))))));
};
export default CryptoAsset;
//# sourceMappingURL=CryptoAsset.js.map